<template >
  <div class="card dash-card" id="legend" >
    <div class="card-header dash-card-header" style="height: 30px; background: transparent; ">
      <h3 class="narrow_05">{{$t('Webportal.Dashboard.PerformanceIndex')}} <span class="text8pt">({{$t('Webportal.Dashboard.AllValuesInPercent')}})</span></h3>
    </div>
    <div class="card-body dash-card-body">

      <div style="margin: 0px 4px;">
        <div class="legctrl-box">
          <div class="legctrl-tab">
            <div class="legctrl-cell bc-red rounded2">0-59</div>
            <div class="legctrl-cell bc-yellow rounded2">60-89</div>
            <div class="legctrl-cell bc-green rounded2">90-100</div>
          </div>
        </div>

        <div v-if="showTextItems" class="legctrl-box">
          <div class="legctrl-tab">
            <div class="legctrl-cell10"><font-awesome-icon name="fa-thumbs-up" icon="star"></font-awesome-icon></div>
            <div class="legctrl-cell90" >{{ workingStandardsText }}</div>
          </div>
        </div>

        <div v-if="showTextItems" class="legctrl-box">
          <div class="legctrl-tab">
            <div class="legctrl-cell20">
              <div class="legctrl-borderbox" ><div></div></div>
            </div>
            <div class="legctrl-cell80">{{ successFactorsText }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LegendControl',

    props:{
      workingStandardsText: { type: String, default: '' },
      successFactorsText: { type: String, default: '' },
      showTextItems: { type: Boolean, default: true }
    },

    computed: {
      getSuccessFactorsGroup: function() {
        return !this.successFactorsKpi ? '-' : this.successFactorsKpi.KpiName;
      },
      getWorkingStandardGroup: function() {
        return !this.workingStandardsKpi ? '-' : this.workingStandardsKpi.KpiName;
      },
    }
  }
</script>


<style scoped>

  h3{
    font-size: 10pt;
    margin: 0pt;
    text-align: center;
    font-stretch: extra-condensed;
    white-space: normal;
    margin-top: 4px;
    font-weight: bold;
  }

  #legend{
    position: relative;
    bottom:0px;
    background: transparent;
    /* height: 136px; */
  }

</style>
